import React, { Component } from 'react';
import SecureLayout from '../../../templates/secure';
import Loading from '../../../elements/loading';
import {NavLink} from 'react-router-dom';
import _ from 'lodash';

class VersionsAdd extends Component{
	render(){
		const {versions, configs} =this.props;
		let rfcPerson = false;
		if (!configs.isFetching) {
			_.map(configs.list, (row, k) => {
				rfcPerson = row && row.name && row.value && row.name === "rfc-person" && row.value === "1";
			})
		}
		let vc = _.find(versions.permissions, (o) => {return o==='Create'});
		return (
			vc ?
				<p>
					{
						_.map(configs.list, (row, k) => {
							if(row && row.name && row.value && row.name === "rfc-person"){
								rfcPerson = row && row.name && row.value && row.name === "rfc-person" && row.value === "1";
								return <button key={k} onClick={() => this._submitForm(row)} className={`button is-small ${rfcPerson ? "is-info" : "is-danger"}`} title="">
									{/* <i className="fa fa-trash-o" /> */}
									{configs.isFetching ? <Loading /> : <b>
										{`RFC - ${rfcPerson ? "Activo" : "Inactivo"}`}
									</b>}
								</button>
							}
							return "";
						})
					}
					{" "}
					<NavLink to={`/versiones/crear`} className="button is-small is-inm-purple">{'Agregar versión'}</NavLink>
				</p>:''
		)
	}

	componentWillMount(){
		this.props.fetchConfigsShow();
	}

	_submitForm(values) {
		if(values && values["id"]){
			let clone = JSON.parse(JSON.stringify(values));
			clone["value"] = clone["value"] === "1" ? "0" : "1";
			this.props.configSave(clone);
		}
	}

	constructor(props) {
		super(props);
		this.state = {
			rfcPerson: false,
			settingData: {},
		}
	}

}

export default SecureLayout(VersionsAdd);


// WEBPACK FOOTER //
// ./src/elements/versions/widget/versions_add.jsx